/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - Portfolio
 * Date: 5/17/21
 * Copyright All Rights Reserved
 */
import { keyBy } from 'lodash/fp';

const buildingTypes = [
  {
    buildingTypeId: 'W1a',
    buildingType: 'WLF: Single Family Dwelling',
  },
  {
    buildingTypeId: 'W2a',
    buildingType: 'WLF: General',
  },
  {
    buildingTypeId: 'W2b',
    buildingType: 'WLF: Over Podium of RC Walls',
  },
  {
    buildingTypeId: 'W2c',
    buildingType: 'WLF: Over Podium of RC Frame',
  },
  {
    buildingTypeId: 'W1a_SST',
    buildingType: 'WLF: Single Family Dwelling with Simpson Strong-Tie Strong Frame SMF',
  },
  {
    buildingTypeId: 'W2a_SST',
    buildingType: 'WLF: General with Simpson Strong-Tie Strong Frame SMF',
  },
  {
    buildingTypeId: 'W1aB_JPN',
    buildingType: 'WLF: Single Family Dwelling - Braced',
  },
  {
    buildingTypeId: 'W1aO_JPN',
    buildingType: 'WLF: Single Family Dwelling - Wall',
  },
  {
    buildingTypeId: 'W2aB_JPN',
    buildingType: 'WLF: General - Braced',
  },
  {
    buildingTypeId: 'W2aO_JPN',
    buildingType: 'WLF: General - Wall',
  },
  {
    buildingTypeId: 'W2bB_JPN',
    buildingType: 'WLF: Brace Over Podium of RC Walls',
  },
  {
    buildingTypeId: 'W2bO_JPN',
    buildingType: 'WLF: Wall Over Podium of RC Walls',
  },
  {
    buildingTypeId: 'W2cB_JPN',
    buildingType: 'WLF: Brace Over Podium of RC Frame',
  },
  {
    buildingTypeId: 'W2cO_JPN',
    buildingType: 'WLF: Wall Over Podium of RC Frame',
  },
  {
    buildingTypeId: 'S1a',
    buildingType: 'Steel: Perimeter Frame',
  },
  {
    buildingTypeId: 'S1d',
    buildingType: 'Steel: Perimeter Frame with Simpson Strong-Tie Yield-Link Connection',
  },
  {
    buildingTypeId: 'S1c',
    buildingType: 'Steel: Perimeter Frame with SidePlate Connection',
  },
  {
    buildingTypeId: 'S1e',
    buildingType: 'Steel: Perimeter Frame with DuraFuse Frame Connections',
  },
  {
    buildingTypeId: 'S1b',
    buildingType: 'Steel: Space Frame',
  },
  {
    buildingTypeId: 'S2a',
    buildingType: 'Steel: Concentric Braced Frame',
  },
  {
    buildingTypeId: 'S2b',
    buildingType: 'Steel: Eccentric Braced Frame',
  },
  {
    buildingTypeId: 'S2c',
    buildingType: 'Steel: BRBF - Generic FEMA P-58',
  },
  {
    buildingTypeId: 'S2d',
    buildingType: 'Steel: BRBF - CoreBrace without Back-up Frame',
  },
  {
    buildingTypeId: 'S2e',
    buildingType: 'Steel: BRBF - CoreBrace with Back-up Frame',
  },
  {
    buildingTypeId: 'S3a',
    buildingType: 'Steel: Light-Frame',
  },
  {
    buildingTypeId: 'S3b',
    buildingType: 'Steel: Light-Frame Over Podium of RC Walls',
  },
  {
    buildingTypeId: 'S3c',
    buildingType: 'Steel: Light-Frame Over Podium of RC Frame',
  },
  {
    buildingTypeId: 'S4a',
    buildingType: 'Steel: RC Shear Wall with Steel Frame',
  },
  {
    buildingTypeId: 'S1a_JPN',
    buildingType: 'Steel: Perimeter Frame',
  },
  {
    buildingTypeId: 'S1b_JPN',
    buildingType: 'Steel: Space Frame',
  },
  {
    buildingTypeId: 'S2a_JPN',
    buildingType: 'Steel: Concentric Braced Frame',
  },
  {
    buildingTypeId: 'S2b_JPN',
    buildingType: 'Steel: Eccentric Braced Frame',
  },
  {
    buildingTypeId: 'S2c_JPN',
    buildingType: 'Steel: BRBF - Generic FEMA P-58',
  },
  {
    buildingTypeId: 'S2d_JPN',
    buildingType: 'Steel: BRBF - CoreBrace without Back-up Frame',
  },
  {
    buildingTypeId: 'S2e_JPN',
    buildingType: 'Steel: BRBF - CoreBrace with Back-up Frame',
  },
  {
    buildingTypeId: 'S3a_JPN',
    buildingType: 'Steel: Light-Frame',
  },
  {
    buildingTypeId: 'S3b_JPN',
    buildingType: 'Steel: Light-Frame Over Podium of RC Walls',
  },
  {
    buildingTypeId: 'S3c_JPN',
    buildingType: 'Steel: Light-Frame Over Podium of RC Frame',
  },
  {
    buildingTypeId: 'C1a',
    buildingType: 'RC: Perimeter Frame',
  },
  {
    buildingTypeId: 'C1b',
    buildingType: 'RC: Space Frame',
  },
  {
    buildingTypeId: 'C2a',
    buildingType: 'RC: Cantilever Shear Wall',
  },
  {
    buildingTypeId: 'C2b',
    buildingType: 'RC: Coupled Shear Wall',
  },
  {
    buildingTypeId: 'C2c',
    buildingType: 'RC: Shear Wall with RC Frame',
  },
  {
    buildingTypeId: 'PC1a',
    buildingType: 'RC: Precast Concrete Walls with Flexible Diaphragms',
  },
  {
    buildingTypeId: 'PC2a',
    buildingType: 'RC: PRESS Frame',
  },
  {
    buildingTypeId: 'C1a_JPN',
    buildingType: 'RC: Perimeter Frame',
  },
  {
    buildingTypeId: 'C1b_JPN',
    buildingType: 'RC: Space Frame',
  },
  {
    buildingTypeId: 'C2a_JPN',
    buildingType: 'RC: Cantilever Shear Wall',
  },
  {
    buildingTypeId: 'C2b_JPN',
    buildingType: 'RC: Coupled Shear Wall',
  },
  {
    buildingTypeId: 'C2c_JPN',
    buildingType: 'RC: Shear Wall with RC Frame',
  },
  {
    buildingTypeId: 'PC1a_JPN',
    buildingType: 'RC: Precast Concrete Walls with Flexible Diaphragms',
  },
  {
    buildingTypeId: 'C1c_JPN',
    buildingType: 'RC: Steel Reinforced Concrete Space Frame',
  },
  {
    buildingTypeId: 'S4a_JPN',
    buildingType: 'Steel: RC Shear Wall with Steel Frame',
  },
  {
    buildingTypeId: 'RM1a',
    buildingType: 'RM: Flexible Diaphragms',
  },
  {
    buildingTypeId: 'RM2a',
    buildingType: 'RM: Rigid Diaphragms',
  },
  {
    buildingTypeId: 'RM1a_JPN',
    buildingType: 'RM: Flexible Diaphragms',
  },
  {
    buildingTypeId: 'RM2a_JPN',
    buildingType: 'RM: Rigid Diaphragms',
  },
];

const buildingTypesById = keyBy('buildingTypeId', buildingTypes);

const getBuildingTypeDescription = id => buildingTypesById[id].buildingType;

export default getBuildingTypeDescription;



// WEBPACK FOOTER //
// ./js/support/getBuildingTypeDescription.js